/*=========================================================================================
  File Name: moduleAdminActions.js
  Description: Admin Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
    addServerMonitoringEmail({ commit }, serverMonitoringEmail) {
        return new Promise((resolve, reject) => {
            axios.post("/api/server-monitoring/server-monitoring-emails",  serverMonitoringEmail)
                .then((response) => {
                    if (response.data.resultCode === 309 && response.data.resultMessage === "DUPLICATE_EMAIL") {
                        reject('DUPLICATE_EMAIL_ERROR')
                    } else if (response.data.resultCode === 300) {
                        reject('INSERT_ERROR')
                    } else if (response.data.resultCode === 200){
                        resolve(response)
                    } else {
                        let error = { message: response.data.resultMessage }
                        reject(error)
                    }

                })
                .catch((error) => { reject(error) })
        })
    },
    updateServerMonitoringEmail({ commit }, serverMonitoringEmail) {
        return new Promise((resolve, reject) => {
            axios.put(`/api/server-monitoring/server-monitoring-emails`, serverMonitoringEmail)
                .then((response) => {
                    if (response.data.resultCode === 309 && response.data.resultMessage === "DUPLICATE_EMAIL") {
                        reject('DUPLICATE_EMAIL_ERROR')
                    } else if (response.data.resultCode === 300) {
                        reject('INSERT_ERROR')
                    } else if (response.data.resultCode === 200){
                        resolve(response)
                    } else {
                        let error = { message: response.data.resultMessage }
                        reject(error)
                    }
                })
                .catch((error) => { reject(error) })
        })
    },
    deleteServerMonitoringEmail({ commit }, seq) {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/server-monitoring/server-monitoring-emails/${seq}`)
                .then((response) => {
                    if (response.data.resultCode === 300) {
                        reject('INSERT_ERROR')
                    } else if (response.data.resultCode === 200){
                        resolve(response)
                    } else {
                        let error = { message: response.data.resultMessage }
                        reject(error)
                    }
                })
                .catch((error) => { reject(error) })
        })
    },
    fetchServerMonitoringLimit({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get(`/api/server-monitoring/server-monitoring-limit`)
                .then((response) => {
                     if (response.data.resultCode === 200){
                        commit('SET_SERVER_MONITORING_LIMIT', response.data)
                        resolve(response)
                    } else {
                        let error = { message: response.data.resultMessage }
                        reject(error)
                    }
                })
                .catch((error) => { reject(error) })
        })
    },
    updateServerMonitoringLimit({ commit }, obj) {
        return new Promise((resolve, reject) => {
            axios.put(`/api/server-monitoring/server-monitoring-limit/${obj.seq}/${obj.limitName}/${obj.limitValue}`)
                .then((response) => {
                     if (response.data.resultCode === 300) {
                        reject('INSERT_ERROR')
                    } else if (response.data.resultCode === 200){
                        resolve(response)
                    } else {
                        let error = { message: response.data.resultMessage }
                        reject(error)
                    }
                })
                .catch((error) => { reject(error) })
        })
    },
    fetchAppVersion({commit}){
        return new Promise((resolve, reject) => {
            axios.get(`/api/app/versions`)
                .then((response) => {
                     if (response.data.resultCode === 300) {
                        reject('INSERT_ERROR')
                    } else if (response.data.resultCode === 200){
                        commit('SET_APP_VERSION', response.data)
                        resolve(response)
                    } else {
                        let error = { message: response.data.resultMessage }
                        reject(error)
                    }
                })
                .catch((error) => { reject(error) })
        })
    },
    updateAppVersion({commint}, obj){
        return new Promise((resolve, reject) => {
            axios.put(`/api/app/versions`, obj)
                .then((response) => {
                     if (response.data.resultCode === 300) {
                        reject('INSERT_ERROR')
                    } else if (response.data.resultCode === 200){
                        resolve(response)
                    } else {
                        let error = { message: response.data.resultMessage }
                        reject(error)
                    }
                })
                .catch((error) => { reject(error) })
        })
    },
    fetchFirmwareVersion({commit}){
        return new Promise((resolve, reject) => {
            axios.get(`/api/firmware/version`)
                .then((response) => {
                     if (response.data.resultCode === 300) {
                        reject('INSERT_ERROR')
                    } else if (response.data.resultCode === 200){
                        commit('SET_FIRMWARE_VERSION', response.data)
                        resolve(response)
                    } else {
                        let error = { message: response.data.resultMessage }
                        reject(error)
                    }
                })
                .catch((error) => { reject(error) })
        })
    },
    updateFirmwareVersion({commint}, obj){
        return new Promise((resolve, reject) => {
            axios.put(`/api/firmware/version/`, obj)
                .then((response) => {
                     if (response.data.resultCode === 300) {
                        reject('INSERT_ERROR')
                    } else if (response.data.resultCode === 200){
                        resolve(response)
                    } else {
                        let error = { message: response.data.resultMessage }
                        reject(error)
                    }
                })
                .catch((error) => { reject(error) })
        })
    },
    addNotice({ commit }, notice) {
        return new Promise((resolve, reject) => {
            axios.post("/api/notice-management/notices",  notice)
                .then((response) => {
                    if (response.data.resultCode === 300) {
                        reject('INSERT_ERROR')
                    } else if (response.data.resultCode === 200){
                        resolve(response)
                    } else {
                        let error = { message: response.data.resultMessage }
                        reject(error)
                    }

                })
                .catch((error) => { reject(error) })
        })
    },
    updateNotice({ commit }, notice) {
        return new Promise((resolve, reject) => {
            axios.put(`/api/notice-management/notices`, notice)
                .then((response) => {
                    if (response.data.resultCode === 300) {
                        reject('INSERT_ERROR')
                    } else if (response.data.resultCode === 200){
                        resolve(response)
                    } else {
                        let error = { message: response.data.resultMessage }
                        reject(error)
                    }
                })
                .catch((error) => { reject(error) })
        })
    },
    getPopupYNotice({ commit }, seq) {
        return new Promise((resolve, reject) => {
            axios.get(`/api/notice-management/popupY/${seq}`)
                .then((response) => {
                    if (response.data.resultCode === 300) {
                        reject('INSERT_ERROR')
                    } else if (response.data.resultCode === 200){
                        resolve(response)
                    } else {
                        let error = { message: response.data.resultMessage }
                        reject(error)
                    }
                })
                .catch((error) => { reject(error) })
        })
    },
    fetchServerMonitoring({commit},obj){
        return new Promise((resolve, reject) => {
            axios.get(`/api/server-monitoring/server-monitoring-history/${obj.serverIp}/${obj.start}/${obj.end}`)
                .then((response) => {
                    if (response.data.resultCode === 200){
                        commit('SET_SERVER_MONITORING', response.data)
                        resolve(response)
                    } else {
                        let error = { message: response.data.resultMessage }
                        reject(error)
                    }
                })
                .catch((error) => { reject(error) })
        })
    },
    fetchServerList({commit}, obj){
        return new Promise((resolve, reject) => {
            axios.get(`/api/server-monitoring/server-monitoring-list/${obj.start}/${obj.end}`)
                .then((response) => {
                    if(response.data.resultBody == ""){
                        let error = { message: "There is no data in the selected period." }
                        reject(error)
                    } else if (response.data.resultCode === 200 ){
                        commit('SET_SERVER_LIST', response.data)
                        resolve(response)
                    } else {
                        let error = { message: response.data.resultMessage }
                        reject(error)
                    }

                })
                .catch((error) => { reject(error) })
        })
    },
    addNotiEmail({ commit }, notiemail) {
        return new Promise((resolve, reject) => {
            axios.post(`/api/noti-email-management/noti-email/`,  notiemail)
                .then((response) => {
                    if (response.data.resultCode === 300) {
                        reject('INSERT_ERROR')
                    } else if (response.data.resultCode === 200){
                        resolve(response)
                    } else {
                        let error = { message: response.data.resultMessage }
                        reject(error)
                    }

                })
                .catch((error) => { reject(error) })
        })
    },
    updateNotiEmail({ commit }, notiemail) {
        return new Promise((resolve, reject) => {
            axios.put(`/api/noti-email-management/noti-email/`,  notiemail)
                .then((response) => {
                    if (response.data.resultCode === 300) {
                        reject('INSERT_ERROR')
                    } else if (response.data.resultCode === 200){
                        resolve(response)
                    } else {
                        let error = { message: response.data.resultMessage }
                        reject(error)
                    }

                })
                .catch((error) => { reject(error) })
        })
    },
    cancleNotiEmail({commit}, seq){
        return new Promise((resolve, reject) => {
            axios.put(`/api/noti-email-management/noti-email/${seq}`)
                .then((response) => {
                    if (response.data.resultCode === 300) {
                        reject('INSERT_ERROR')
                    } else if (response.data.resultCode === 200){
                        resolve(response)
                    } else {
                        let error = { message: response.data.resultMessage }
                        reject(error)
                    }
                })
                .catch((error) => { reject(error) })
        })
    }
}